// extracted by mini-css-extract-plugin
export default {"cls1":"UserTaggingPingBodyStyles-cls1___958796847615132e70a","cls2":"UserTaggingPingBodyStyles-cls2__d070999850e6ea744a3f UserTaggingPingBodyStyles-cls1___958796847615132e70a"};